import React from 'react'
import { shallow } from 'enzyme'
import Row from '../../components/Row'

describe('Row', () => {
  let wrapper, props, instance

  beforeAll( () => {
    props = {
      row :{
        object: {
          __typename: 'Answer',
          rid: 1
        },
        label: 'Label'
      },
      columnSize: 2
    }
    wrapper = shallow(<Row {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe('#renderColumns', () => {
    it('should return obj', () => {
      const { renderColumns } = instance

      expect(renderColumns()).toBeTruthy()
    })
  })

  describe('#renderEditResolver', () => {
    it('should return obj', () => {
      const { renderEditResolver } = instance

      expect(renderEditResolver()).toBeTruthy()
    })
  })
})